import type { JSX } from "react";

import { AlertDialog as BaseAlertDialog } from "@base-ui/react/alert-dialog";
import { Button } from "@frontend/components/atoms/Button";

import type { AlertDialogCancelProps } from "./AlertDialog.types";

// No dedicated stylesheet: Button already carries all the visual weight
// needed here, unlike Dialog's icon-only Close button.
export function AlertDialogCancel({
  children,
  ...props
}: AlertDialogCancelProps): JSX.Element {
  return (
    <BaseAlertDialog.Close
      data-slot="alert-dialog-cancel"
      render={<Button variant="secondary" size="md" />}
      {...props}
    >
      {children}
    </BaseAlertDialog.Close>
  );
}
